import { render } from "./loaderComponent.vue?vue&type=template&id=194eb8be"
import script from "./loaderComponent.vue?vue&type=script&lang=js"
export * from "./loaderComponent.vue?vue&type=script&lang=js"

import "./loaderComponent.vue?vue&type=style&index=0&id=194eb8be&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__